// extracted by css-extract-rspack-plugin
export default {"bar":"crhdy","progress":"SChbQ"};